export const hourInSeconds = 60 * 60;
